import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faHeart, faUserPlus, faComments } from '@fortawesome/free-solid-svg-icons';

const MetricsCards: React.FC = () => {
  return (
    <div id="metrics-cards" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10 hover:border-purple-400/50 transition-all">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-700 rounded-xl flex items-center justify-center">
            <FontAwesomeIcon icon={faEye} className="text-white text-lg" />
          </div>
          <span className="text-green-400 text-sm font-medium">+12.5%</span>
        </div>
        <h3 className="text-2xl font-bold text-white mb-1">2.4M</h3>
        <p className="text-white/50 text-sm">Toplam Görüntülenme</p>
        <div className="mt-4 h-1 bg-white/10 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-purple-500 to-purple-700 w-3/4"></div>
        </div>
      </div>

      <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10 hover:border-blue-400/50 transition-all">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-blue-600 rounded-xl flex items-center justify-center">
            <FontAwesomeIcon icon={faHeart} className="text-white text-lg" />
          </div>
          <span className="text-green-400 text-sm font-medium">+8.3%</span>
        </div>
        <h3 className="text-2xl font-bold text-white mb-1">156K</h3>
        <p className="text-white/50 text-sm">Etkileşim Oranı</p>
        <div className="mt-4 h-1 bg-white/10 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-blue-400 to-blue-600 w-2/3"></div>
        </div>
      </div>

      <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10 hover:border-green-400/50 transition-all">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-gradient-to-br from-green-400 to-green-600 rounded-xl flex items-center justify-center">
            <FontAwesomeIcon icon={faUserPlus} className="text-white text-lg" />
          </div>
          <span className="text-green-400 text-sm font-medium">+15.7%</span>
        </div>
        <h3 className="text-2xl font-bold text-white mb-1">12.8K</h3>
        <p className="text-white/50 text-sm">Yeni Takipçi</p>
        <div className="mt-4 h-1 bg-white/10 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-green-400 to-green-600 w-4/5"></div>
        </div>
      </div>

      <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10 hover:border-pink-400/50 transition-all">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-gradient-to-br from-pink-400 to-pink-600 rounded-xl flex items-center justify-center">
            <FontAwesomeIcon icon={faComments} className="text-white text-lg" />
          </div>
          <span className="text-red-400 text-sm font-medium">-2.1%</span>
        </div>
        <h3 className="text-2xl font-bold text-white mb-1">3.2K</h3>
        <p className="text-white/50 text-sm">Yorum</p>
        <div className="mt-4 h-1 bg-white/10 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-pink-400 to-pink-600 w-1/2"></div>
        </div>
      </div>
    </div>
  );
};

export default MetricsCards;
